import {
  getPageExcludeSelector,
  removeScopedStyleTag,
  upsertScopedStyleTag,
} from "../../domStyles";
import { getFeatureTarget } from "../../featureTargets";

const FEATURE_ID = "highlight-titles";
const STYLE_ID = "incluway-highlight-titles-style";

const TITLE_SELECTOR = [
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  '[role="heading"]',
  "[aria-level]",
].join(",");

export function highlightTitles() {
  const exclude = getPageExcludeSelector();

  upsertScopedStyleTag({
    id: STYLE_ID,
    target: getFeatureTarget(FEATURE_ID, "both"),
    pageCss: `
${TITLE_SELECTOR}${exclude} {
  outline: 2px solid #ffb020 !important;
  outline-offset: 2px !important;
  border-radius: 6px !important;
}
`.trim(),
    widgetCss: `
${TITLE_SELECTOR} {
  outline: 2px solid #ffb020 !important;
  outline-offset: 2px !important;
  border-radius: 6px !important;
}
`.trim(),
  });
}

export function unHighlightTitles() {
  removeScopedStyleTag(STYLE_ID);
}
